import { createAction } from '@lifesize/typescript-react-redux-utils';
import { RecordingRequestObjectFeed } from 'constants/recordingsConstants';
import { UploadStatusResponse } from 'interfaces/Recording';
import { getUploadsStatus } from 'utils/uploadRecordingUtils';
import _get from 'lodash/get';

export enum RecordingsActionType {
  RECORDINGS_LOAD_RECORDS = 'RECORDINGS_LOAD_RECORDS',
  RECORDINGS_SEARCH_CHANGE = 'RECORDINGS_SEARCH_CHANGE',
  RECORDINGS_SEARCH_SELECT = 'RECORDINGS_SEARCH_SELECT',
  RECORDINGS_SORT_CHANGE = 'RECORDINGS_SORT_CHANGE',
  RECORDINGS_FILTER_CHANGE = 'RECORDINGS_FILTER_CHANGE',
  RECORDINGS_LAYOUT_CHANGE = 'RECORDINGS_LAYOUT_CHANGE',
  RECORDINGS_PAGE_CHANGE = 'RECORDINGS_PAGE_CHANGE',
  RECORDINGS_FETCH_DATA = 'RECORDINGS_FETCH_DATA',
  RECORDINGS_FETCH_WATCH_LIST = 'RECORDINGS_FETCH_WATCH_LIST',
  RECORDINGS_FETCH_MY_RECORDINGS = 'RECORDINGS_FETCH_MY_RECORDINGS',
  RECORDINGS_ADD_TO_WATCHLIST = 'RECORDINGS_ADD_TO_WATCHLIST',
  RECORDINGS_DELETE_RECORDING = 'RECORDINGS_DELETE_RECORDING',
  RECORDINGS_RESET_RECORDING_PROPS = 'RECORDINGS_RESET_RECORDING_PROPS',
  RECORDINGS_SET_SINGLE_ID = 'RECORDINGS_SET_SINGLE_ID',
  RECORDINGS_CLEAR_SEARCH_RESULTS = 'RECORDINGS_CLEAR_SEARCH_RESULTS',
  RECORDINGS_PENDING_RESULTS = 'RECORDINGS_PENDING_RESULTS',
  RECORDINGS_SEARCH_ID = 'RECORDINGS_SEARCH_ID',
  RECORDINGS_SEARCH_NAME = 'RECORDINGS_SEARCH_NAME',
  RECORDINGS_ADD_PROCESSING_UPLOAD = 'RECORDINGS_ADD_PROCESSING_UPLOAD',
  RECORDINGS_SET_UPLOADS_STATUS = 'RECORDINGS_SET_UPLOADS_STATUS',
}

const actions = {
  recordingPendingResults: () =>
    createAction(RecordingsActionType.RECORDINGS_PENDING_RESULTS),
  clearSearchResults: () =>
    createAction(RecordingsActionType.RECORDINGS_CLEAR_SEARCH_RESULTS),
  handleLoadRecords: (payload: RecordingRequestObjectFeed) =>
    createAction(RecordingsActionType.RECORDINGS_LOAD_RECORDS, payload),
  handlePageChange: (payload: number) => createAction(RecordingsActionType.RECORDINGS_PAGE_CHANGE, payload),
  handleResetRecordingProps: () =>
    createAction(RecordingsActionType.RECORDINGS_RESET_RECORDING_PROPS),
  handleSearchChange: (payload: string) => createAction(RecordingsActionType.RECORDINGS_SEARCH_CHANGE, payload),
  handleSearchSelect: (payload: string) => createAction(RecordingsActionType.RECORDINGS_SEARCH_SELECT, payload),
  handleSortChange: (payload: string) => createAction(RecordingsActionType.RECORDINGS_SORT_CHANGE, payload),
  handleDateFilterChange: (payload: string) => createAction(RecordingsActionType.RECORDINGS_FILTER_CHANGE, payload),
  handleLayoutChange: (payload: boolean) => createAction(RecordingsActionType.RECORDINGS_LAYOUT_CHANGE, payload),
  handleFetchFeedData: () => createAction(RecordingsActionType.RECORDINGS_FETCH_DATA),
  handleFetchMyRecordings: (payload: RecordingRequestObjectFeed) =>
    createAction(RecordingsActionType.RECORDINGS_FETCH_MY_RECORDINGS, payload),
  handleFetchWatchList: (payload: RecordingRequestObjectFeed) =>
    createAction(RecordingsActionType.RECORDINGS_FETCH_WATCH_LIST, payload),
  handleAddToWatchList: (payload: string) =>
    createAction(RecordingsActionType.RECORDINGS_ADD_TO_WATCHLIST, payload),
  handleDeleteRecording: (payload: string) =>
    createAction(RecordingsActionType.RECORDINGS_DELETE_RECORDING, payload),
  setRecordingSearchId: (meetingId?: string) => {
    return createAction(RecordingsActionType.RECORDINGS_SEARCH_ID, meetingId);
  },
  setRecordingSearchName: (meetingName?: string) => {
    return createAction(RecordingsActionType.RECORDINGS_SEARCH_NAME, meetingName);
  },
  setRecordingId: (id: string) => {
    return createAction(RecordingsActionType.RECORDINGS_SET_SINGLE_ID, id);
  },
  addProcessingUpload: (status: UploadStatusResponse) => {
    return createAction(RecordingsActionType.RECORDINGS_ADD_PROCESSING_UPLOAD, status);
  },
  getUploadsStatus: () => {
    return async (dispatch: Function) => {
      const res = await getUploadsStatus();
      return dispatch({
        type: RecordingsActionType.RECORDINGS_SET_UPLOADS_STATUS,
        payload: _get(res, 'uploads', [])
      });
    };
  }
};

export default actions;
